import React from "react";
import OrangeBackground from "../../assets/about/OrangeBackground.png";
import ChooseEng1 from "../../assets/about/choose-eng1.png";
import ChooseEng2 from "../../assets/about/choose-eng2.png";
import ChooseEng3 from "../../assets/about/choose-eng3.png";
import Image from "../../components/general/Image";

const content = [
    {
        img: ChooseEng1,
        title: "Timezone-matched engineers",
        desc: "Developers who work in your hours, attend your standups, and integrate like in-house."
    },
    {
        img: ChooseEng2,
        title: "100+ technologies covered",
        desc: "From React to Rust, AI to DevOps — we’ve got specialists across every stack."
    },
    {
        img: ChooseEng3,
        title: "Fully managed contracts",
        desc: "We handle compliance, payroll, and paperwork so you can stay focused on building."
    }
]

const EngineerSection = () => {
    const backgroundStyles = {
        backgroundImage: `url(${OrangeBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'initial',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#000000'
    }

    return (
        <section className="!py-[100px]" style={backgroundStyles}>
            <div className="--layout-padding max-width">
                <div className="flex flex-col gap-[20px] md:grid md:grid-cols-2 lg:grid-cols-3 lg:px-[100px] lg:gap-[50px]">
                    {
                        content.map((item, index) => (
                            <div key={index} className="bg-white rounded-[20px] text-292929 py-[50px] px-[20px]">
                                <Image src={item.img} alt={item.title} className='mb-[20px]' />
                                <h3 className="text-[25px] font-semibold text-[#292929]">{item.title}</h3>
                                <p className="text-[14px] text-[#181818]">{item.desc}</p>
                            </div>
                        ))
                    }
                </div>
            </div>
        </section>
    );
};
export default EngineerSection;